import React from 'react'
import ConstantsUtil from '../../context/constantsUtil'
import SessionStorageService from './sessionStorageService'

export const userLoggedIn = 'userLoggedIn'
export const provisionalApiContextPath = 'provisionalApiContextPath'
export const blockui = 'blockui'
export const refresh = 'refresh'
export const empresa = 'empresa'
export const apiContextPath = 'apiContextPath'
export const perfilLabel = 'perfil'
export const isAuth = 'isAuth'
export const configuracaoEmpresa = 'configuracaoEmpresa'
export const isAdmin = 'isAdmin'
export const email = 'email'
export const lastCheckDate = 'lastCheckDate'
export const preferenciasUsuario = 'preferenciasUsuario'
const Service = SessionStorageService

class AuthService extends React.Component {

    // static isUserLoggedIn(){
    //     const user = Service.getItem(userLoggedIn)
    //     return user && user.id
    // }

    static isAuth(){
        const user = this.getUserLoggedIn()
        if(!user){
            return false
        }
        return user[isAuth];
    }

    static getConfiguracaoEmpresa(){
        const user = this.getUserLoggedIn()
        if(!user){
            return {}
        }
        let configuracao = user[configuracaoEmpresa]
        return configuracao ? configuracao : {};
    }

    static verificaConfiguracao(nomeConfiguracao){
        let configuracao = this.getConfiguracaoEmpresa()
        // console.log("configuracao: ", configuracao)
        return configuracao[nomeConfiguracao]
    }

    static getPerfil(){
        const user = this.getUserLoggedIn()
        if(!user){
            return {}
        }
        return {
            isAdmin: (user.perfil === ConstantsUtil.perfilAdministradorLabel) || (user.perfil === ConstantsUtil.perfilSistemaLabel),
            isOperadorBancario: user.perfil === ConstantsUtil.perfilOperadorBancarioLabel,
            isOperador: user.perfil === ConstantsUtil.perfilOperadorLabel,
            isOperadorCego: user.perfil === ConstantsUtil.perfilOperadorCegoLabel,
            isAlmoxarife: user.perfil === ConstantsUtil.perfilAlmoxarifeLabel,
            isDiretor: user.perfil === ConstantsUtil.perfilDiretorLabel,
            isOperadorPagamentoDinheiro: user.perfil === ConstantsUtil.perfilOperadorPagamentoDinheiroLabel
        };
    }

    static getUserLoggedIn(){
        return Service.getItem(userLoggedIn)
    }

    // static token(){
    //     return Service.getItem(userToken)
    // }

    static getProvisionalApiContextPath(){
        return Service.getItem(provisionalApiContextPath)
    }

    static addProvisionalApiContextPath(path){
        return Service.addItem(provisionalApiContextPath, path)
    }

    static putEmpresa(nomeEmpresa){
        Service.addItem(empresa, nomeEmpresa)
    }

    static getEmpresa(){
        return Service.getItem(empresa)
    }

    static startBlockUi(){
        Service.addItem(blockui, true)
    }

    static stopBlockUi(){
        Service.addItem(blockui, false)
    }

    static isBlockUi(){
        return Service.getItem(blockui)
    }

    static alreadyRefresh(){
        let alreadyRefresh = Service.getItem(refresh)
        if(alreadyRefresh){
            return true
        }
        return false
    }
    static makrRefresh(){
        Service.addItem(refresh, true)
    }

    static getCurrentContextPath(){
        const user = this.getUserLoggedIn()
        var currentApiContextPath = user[apiContextPath]
        if(!currentApiContextPath){
            currentApiContextPath = this.getProvisionalApiContextPath()
        }
        return currentApiContextPath
    }

    static getAcessToken(){
        const user = this.getUserLoggedIn()
        return user.accessToken
    }

    static changeCurrentContextPath(path){
        var user = this.getUserLoggedIn()
        user[apiContextPath] = path
        Service.addItem(userLoggedIn, user)
    }
    
    static login(user) {
        Service.addItem(userLoggedIn, {
            [apiContextPath]: user.apiContextPath,
            [isAuth]: true,
            [configuracaoEmpresa]: user.configuracaoEmpresa,
            [email]: user.email,
            [perfilLabel]: user.perfil,
            [ConstantsUtil.accessToken]: user.accessToken,
            [lastCheckDate]: Date.now(),
            [preferenciasUsuario]: user.preferenciasUsuario,
        })
        Service.removeItem(provisionalApiContextPath)
    }

    static logOut(){
        Service.removeItem(userLoggedIn)
    }

    static getCheckDate(){
        return Service.getItem(lastCheckDate)
    }

    static getPreferenciaUsuario(chave){
        const user = this.getUserLoggedIn()
        const preferencias = user ? user[preferenciasUsuario] : null
        const valor = preferencias ? preferencias[chave] : null
        if(!valor){
            return null
        }
        try{
            return JSON.parse(valor)
        } catch(e){
            return valor
        }
    }

    static atualizaPreferenciaUsuario(chave, valor){
        var user = this.getUserLoggedIn()
        if(!user[preferenciasUsuario]){
            user[preferenciasUsuario] = {}
        }
        user[preferenciasUsuario][chave] = JSON.stringify(valor)
        Service.addItem(userLoggedIn, user)
    }

}

export default AuthService